import {
    getField,
    updateField
} from "vuex-map-fields"
import { notify, sendRequest } from "../../api"
import {
    RESET_FORM
} from "../../constant-types"
import { getDeliverableType, getInvoiceCode } from "../../helper"

const getDefaultState = () => {
    return {
        id: '',
        senderable_id: '',
        senderable_type: '',
        delivery_type: '', // receive | sender
        ship_date: (new Date()).toISOString().split('T')[0],
        delivery_code: '',
        receiver_name: '',
        sender_name: '',
        sales_name: '',
        memo: '',
        stock_delivery_items: []
    }
}

const getDefaultItemsState = () => ({
    id: '',
    stock_delivery_id: '',
    transaction: null,
    deliverable_type: '',
    deliverable_id: '',
    product_id: '',
    qty: 0,
    unit_id: '',
    invoice_code: '',
    warehouse_id: '',
    // reference
    warehouse_stock_options: [],
    warehouse_stock_loading: false, // show when fetching
    qty_total: 0,
    qty_delivered_sum: 0, 
    qty_remain: 0,
    qty_remain_after_current: 0,
    unit: null
})

export default ({
    namespaced: true, 
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        ADD_ITEM(state) {
            // delivery type must available
            if (state.delivery_type && state.senderable_id) {
                state.stock_delivery_items.push(getDefaultItemsState())
            } else {
                notify('info', 'tipe / tujuan / penerima belum diisi')
            }
        },
        REMOVE_ITEM(state, idx) {
            state.stock_delivery_items.splice(idx, 1)
        },
        RESET_ITEM(state) {
            state.stock_delivery_items = []
        },
        RESET_SENDERABLE(state) {
            state.senderable_id = ''
            state.senderable_type = ''
        },
        UPDATE_ITEM(state, { transactionItem, item}) {
            item.invoice_code = getInvoiceCode(transactionItem)
            item.unit = transactionItem.unit
            item.unit_id = transactionItem.unit.id
            item.product_id = transactionItem.product_id
            item.deliverable_id = transactionItem.id
            item.deliverable_type = getDeliverableType(transactionItem)
            // qty calculation
            item.qty_total = transactionItem.stock_delivery_total
            item.qty_delivered_sum = transactionItem.qty_delivered_sum ? transactionItem.qty_delivered_sum : 0
            item.qty_remain = item.qty_total - item.qty_delivered_sum
            item.qty = item.qty_remain
            item.qty_remain_after_current = item.qty_remain - item.qty
        },
        CALCULATE_QTY(state, item) {
            item.qty_remain_after_current = item.qty_remain - item.qty
        },
        [RESET_FORM](state) {
            Object.assign(state, getDefaultState())
        },
        SET_WAREHOUSE_STOCK_OPTIONS(state, { itemIndex, options }) {
            state.stock_delivery_items[itemIndex].warehouse_stock_options = options
        },
        SET_WAREHOUSE_STOCK_OPTIONS_LOADING(state, { itemIndex, loading }) {
            state.stock_delivery_items[itemIndex].warehouse_stock_loading = loading
        },
        updateField
    },
    // can async
    actions: {
        loadWarehouseStockOptions({commit, state}, { itemIndex, productId }) {
            commit('SET_WAREHOUSE_STOCK_OPTIONS_LOADING', { itemIndex, loading: true })
            return sendRequest('stock-warehouse/warehouse-with-related-stock', { related_product_id : productId }, 'get', (successResponse) => {
                commit('SET_WAREHOUSE_STOCK_OPTIONS', { itemIndex, options: successResponse })
                commit('SET_WAREHOUSE_STOCK_OPTIONS_LOADING', { itemIndex, loading: false })
            })
        },
        async updateItem({commit, state, dispatch}, { transactionItem, item, itemIndex }) {
            await dispatch('loadWarehouseStockOptions',{ itemIndex, productId : transactionItem.product_id } )
            commit("UPDATE_ITEM", { transactionItem, item })
        },
        loadSaleDeliveryCode({commit, state}) {
            return sendRequest('stock-delivery/sale-delivery-code', {}, 'get', (successResponse) => {
                commit('updateField', { path: 'delivery_code', value: successResponse.sale_delivery_code })
            })
        },
        handleAfterDeliveryTypeSelected({commit, dispatch, state}) {
            commit('RESET_ITEM')
            commit('RESET_SENDERABLE')
            // only generate when it's sale alias send
            if ( state.delivery_type === 'send' ) {
                dispatch('loadSaleDeliveryCode')
            } else {
                // should reset when change back
                commit('updateField', { path: 'delivery_code', value: '' })
            }
        }
    },
    // call variable with custom display
    getters: {
        getField
    }
})
